// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__yuBKz","imageLoading":"Loading_imageLoading__xZodj"};